import React from "react";
import LazyloadImage from "./LazyloadImage";

export default class TopPickCarouselImage extends React.Component {
  static defaultProps = {
    containerClassName: 'top-pick-image-container',
    desktopWidth: 515,
    mobileWidth: 207
  };

  render() {
    return <LazyloadImage {...this.props} />
  }
}